import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  setLanguageNumber,
  setSelectedLanguage,
} from "../../data/reducer/language.reducer";
import useLanguage from "../../data/talons/Language/useLanguage";
import useInstruction from "../../data/talons/Instruction/useInstruction";

export default function DropDown2({
  values,
  className,
  selected,
  language,
  setLanguage,
  onClick,
  // handleLanguageChange,
}) {
  const [value, setValue] = useState("");
  const dispatch = useDispatch();
  const { updateLanguages } = useLanguage();
  const { fetchInstruction, Instructions } = useInstruction();
  const handleChange = (e) => {
    const selectedValue = e.target.value;
    // console.log(e.target.value);
    setValue(selectedValue);
    setLanguage && setLanguage(selectedValue);
    // handleLanguageChange(selectedValue);
    dispatch(setLanguageNumber(selectedValue));
    updateLanguages(selectedValue);
    fetchInstruction();
    onClick && onClick(selectedValue);
  };

  return (
    <div className={`select-wrapper ${className}`}>
      <select
        id="dropdown"
        className="form-select"
        value={value}
        onChange={handleChange}
      >
        <option value="">{selected}</option>
        {values?.map((item) => {
          return (
            <option
              onClick={onClick}
              className="p-3 "
              key={item.id}
              value={item.id}
            >
              {item.name}
            </option>
          );
        })}
      </select>
      {/* {console.log(value)}
      {console.log(language, "fdasfjjafjfdbk")} */}
    </div>
  );
}
